//#region IMPORTS
import { InstoreTheme } from "../../models/instoreTheme";
import InstoreThemesTableRowActionEdit from "./InstoreThemesTableRowActionEdit";
import MainTableRowActionDelete from "../_layout/MainTableRowActionDelete";
//#endregion

//#region INTERFACE
interface Props {
  deleteHandler: () => void;
  instoreTheme: InstoreTheme;
  editHandler: () => void;
  loading?: boolean;
}
//#endregion

export default function InstoreThemesTableRow({
  deleteHandler,
  instoreTheme,
  editHandler,
  loading,
}: Props) {
  //#region RENDER
  return (
    <tr className="border-t border-slate-300 h-10">
      {/* read */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-500 sm:pl-0">
        <InstoreThemesTableRowActionEdit
          instoreTheme={instoreTheme}
          editHandler={editHandler}
          disabled={loading || instoreTheme.name.toUpperCase() === "DEFAULT"}
        />
      </td>

      {/* name */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-500 sm:pl-0">
        {instoreTheme.name}
      </td>

      {/* Delete */}
      <td className="whitespace-nowrap px-2 text-left text-xs text-gray-900">
        <MainTableRowActionDelete
          deleteHandler={deleteHandler}
          tooltipId={`instoreTheme${instoreTheme.id}`}
          disabled={loading || instoreTheme.name.toUpperCase() === "DEFAULT"}
        />
      </td>
    </tr>
  );
  //#endregion
}
